export class CostReviewDampers {
  receivedBindingQuote!: number;
  damperQuoteAmount!: number;
  numberOfDampers!: number;
  manufacturer!: string;
  actuatorsFurnishedBy!: number;
  actuatorsInstalledBy!: number;
  actuatorsWiredBy!: number;
  specialApplications!: string;
  isDampersApplicable!: boolean;
}
